import { BehaviorSubject, Observable } from 'rxjs';
import { DEFAULT_LANGUAGE } from '../commons/constants';
import { environment } from '../../environments/environment';
import { Injectable } from '@angular/core';

export type SupportedLanguage = 'en' | 'nl' | 'fr';

@Injectable({
  providedIn: 'root'
})
export class LangService {
  private readonly supportedLanguages: SupportedLanguage[] = ['en', 'nl', 'fr'];

  private readonly currentLanguageSubject = new BehaviorSubject<SupportedLanguage>(this.getDefaultLanguage());
  readonly currentLanguage$: Observable<SupportedLanguage> = this.currentLanguageSubject.asObservable();

  setLanguage(language: SupportedLanguage): void {
    this.currentLanguageSubject.next(language);
  }

  getSupportedLanguages(): SupportedLanguage[] {
    return [...this.supportedLanguages];
  }

  getDefaultLanguage(): SupportedLanguage {
    return environment.defaultLanguage ?? DEFAULT_LANGUAGE as SupportedLanguage;
  }
}
